@switch (skeletonRoute) {
@case ('availability') {
<ng-container *ngTemplateOutlet="upsellSkeleton"></ng-container>
}
@case ('shopping-cart') {
<ng-container *ngTemplateOutlet="shoppingCartSkeleton; context: {isConfirmation: false, displayMessageSkeleton: false}">
</ng-container>
}
@case ('confirmation') {
<ng-container *ngTemplateOutlet="shoppingCartSkeleton; context: {isConfirmation: true, displayMessageSkeleton: true}">
</ng-container>
}
@case ('manage-booking/confirmation') {
<ng-container *ngTemplateOutlet="shoppingCartSkeleton; context: {isConfirmation: true, displayMessageSkeleton: false}">
</ng-container>
}
@case ('manage-booking/retrieve') {
<ng-container *ngTemplateOutlet="retrieveSkeleton"></ng-container>
}
@case ('timetable') {
<ng-container *ngTemplateOutlet="timetableSkeleton"></ng-container>
}
}

<ng-template #upsellSkeleton>
  <refx-basic-in-flow-layout>
    <refx-flight-recap-skeleton-pres summaryPanel>
    </refx-flight-recap-skeleton-pres>

    <refx-page-title-skeleton-pres pageHeader>
    </refx-page-title-skeleton-pres>

    <div mainContent class="upsell-main-content-skeleton">
      <refx-calendar-skeleton-pres>
      </refx-calendar-skeleton-pres>

      <refx-upsell-premium-skeleton-pres [nbRows]="6">
      </refx-upsell-premium-skeleton-pres>
    </div>
  </refx-basic-in-flow-layout>
</ng-template>

<ng-template #shoppingCartSkeleton let-isConfirmation="isConfirmation"
  let-displayMessageSkeleton="displayMessageSkeleton">
  <refx-basic-layout>
    <refx-page-title-skeleton-pres pageHeader [displaySubtitleSkeleton]="!isConfirmation">
    </refx-page-title-skeleton-pres>

    @if (displayMessageSkeleton) {
    <div messagePanel>
      <refx-messages-panel-skeleton-pres>
      </refx-messages-panel-skeleton-pres>
    </div>
    }

    <div mainContent>
      @if (isConfirmation) {
      <refx-flight-confirmation-skeleton-pres>
      </refx-flight-confirmation-skeleton-pres>
      }

      <refx-itinerary-card-skeleton-pres [class.confirmation-itinerary-card-skeleton]="isConfirmation"
        [nbBounds]="nbBounds">
      </refx-itinerary-card-skeleton-pres>

      @if (selectedDataType === 'Order') {
      <refx-passenger-recap-skeleton-pres [travelers]="travelers"
        [class.confirmation-passenger-recap-skeleton]="isConfirmation">
      </refx-passenger-recap-skeleton-pres>
      <refx-service-catalog-skeleton-pres [services]="services"
        [class.confirmation-service-catalog-skeleton]="isConfirmation">
      </refx-service-catalog-skeleton-pres>
      }
    </div>

    <div footer>
      <refx-price-information-skeleton-pres></refx-price-information-skeleton-pres>
      @if (!isConfirmation) {
      <div class="shopping-cart-button-skeleton-container">
        <ngx-skeleton-loader count="1" class="shopping-cart-button-skeleton">
        </ngx-skeleton-loader>
      </div>
      }
    </div>
  </refx-basic-layout>
</ng-template>

<ng-template #retrieveSkeleton>
  <refx-basic-layout>
    <div mainContent class="retrieve-main-content">
      <div class="identification-card">
        <ngx-skeleton-loader appearance="line" class="identification-title-skeleton">
        </ngx-skeleton-loader>
        <refx-identification-skeleton-pres></refx-identification-skeleton-pres>
      </div>
    </div>
  </refx-basic-layout>
</ng-template>

<ng-template #timetableSkeleton>
  <refx-basic-in-flow-layout>
    <refx-page-title-skeleton-pres pageHeader>
    </refx-page-title-skeleton-pres>

    <refx-flight-recap-skeleton-pres summaryPanel>
    </refx-flight-recap-skeleton-pres>

    <div mainContent class="timetable-skeleton">
      <refx-timetable-skeleton-pres [nbRows]="6"></refx-timetable-skeleton-pres>
    </div>
  </refx-basic-in-flow-layout>
</ng-template>